import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { UserSummary } from '@module/user';
import { Entity, Guard, Result, UniqueEntityID } from '@digibricks/core';
import { ConfigType } from '../data-config';
import { SubmissionReport } from '../submission/submission-report';
import { AssignmentStatus } from '../assignment-status';
import { SubmissionOverviewStatus } from '../submission-overview-status';
import { UnixTimestamp } from '../unix-timestamp';
export var ParticipatedAssignmentResponder = /*#__PURE__*/function (_Entity) {
  _inherits(ParticipatedAssignmentResponder, _Entity);

  var _super = _createSuper(ParticipatedAssignmentResponder);

  function ParticipatedAssignmentResponder() {
    _classCallCheck(this, ParticipatedAssignmentResponder);

    return _super.apply(this, arguments);
  }

  _createClass(ParticipatedAssignmentResponder, [{
    key: "idNumber",
    get: function get() {
      return this.props.idNumber;
    }
  }, {
    key: "title",
    get: function get() {
      return this.props.title;
    }
  }, {
    key: "type",
    get: function get() {
      return this.props.type;
    }
  }, {
    key: "duration",
    get: function get() {
      return this.props.duration;
    }
  }, {
    key: "numberOfSubmission",
    get: function get() {
      return this.props.numberOfSubmission;
    }
  }, {
    key: "endTime",
    get: function get() {
      return this.props.endTime;
    }
  }, {
    key: "startTime",
    get: function get() {
      return this.props.startTime;
    }
  }, {
    key: "scoreVisibilityType",
    get: function get() {
      return this.props.scoreVisibilityType;
    }
  }, {
    key: "hasPublishedScoreInformation",
    get: function get() {
      return this.props.hasPublishedScoreInformation;
    }
  }, {
    key: "systemStatus",
    get: function get() {
      return this.props.systemStatus;
    }
  }, {
    key: "report",
    get: function get() {
      return this.props.report;
    }
  }, {
    key: "createdBy",
    get: function get() {
      return this.props.createdBy;
    }
  }, {
    key: "assigner",
    get: function get() {
      return this.props.assigner;
    }
  }, {
    key: "isOverdue",
    value: function isOverdue(now) {
      var _this$props$completed, _this$report$status;

      var deadline = UnixTimestamp.parseMilliseconds((_this$props$completed = this.props.completedAt) !== null && _this$props$completed !== void 0 ? _this$props$completed : this.endTime);
      return ((_this$report$status = this.report.status) === null || _this$report$status === void 0 ? void 0 : _this$report$status.id) === SubmissionOverviewStatus.unFinished.value && deadline !== null && deadline <= now;
    }
  }, {
    key: "canOpen",
    value: function canOpen(now) {
      var _this$report$status2, _this$systemStatus;

      var start = UnixTimestamp.parseMilliseconds(this.startTime);
      var end = UnixTimestamp.parseMilliseconds(this.endTime);
      return !this.props.completedAt && ((_this$report$status2 = this.report.status) === null || _this$report$status2 === void 0 ? void 0 : _this$report$status2.id) === SubmissionOverviewStatus.unFinished.value && ((_this$systemStatus = this.systemStatus) === null || _this$systemStatus === void 0 ? void 0 : _this$systemStatus.id) === AssignmentStatus.ACTIVE && (start === null || start <= now) && (end === null || end > now);
    }
  }, {
    key: "withAssigner",
    value: function withAssigner(assigner) {
      return new ParticipatedAssignmentResponder(_objectSpread(_objectSpread({}, this.props), {}, {
        assigner: assigner
      }), this.id);
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return _objectSpread({}, this.props);
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollections = [{
        argument: props.id,
        argumentName: 'Id'
      }, // {
      //   argument: props.idNumber,
      //   argumentName: 'idNumber',
      // },
      {
        argument: props.title,
        argumentName: 'Title'
      }, {
        argument: props.type,
        argumentName: 'Type'
      }, // {
      //   argument: props.endTime,
      //   argumentName: 'End time',
      // },
      {
        argument: props.report,
        argumentName: 'Submission report'
      }, {
        argument: props.createdBy,
        argumentName: 'Created By'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollections);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok(new ParticipatedAssignmentResponder(props, new UniqueEntityID(props.id)));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var reportProps = data.report instanceof SubmissionReport ? data.report.toJsonObject() : data.report;
        var report = SubmissionReport.create(reportProps).getValue();
        return this.create({
          id: data.id,
          idNumber: data.idNumber,
          title: data.title,
          type: ConfigType.create({
            id: data.type.id,
            name: data.type.name
          }).getValue(),
          endTime: data.endTime,
          completedAt: data.completedAt,
          duration: data.duration,
          numberOfSubmission: data.numberOfSubmission,
          startTime: data.startTime,
          scoreVisibilityType: data.scoreVisibilityType,
          hasPublishedScoreInformation: data.hasPublishedScoreInformation,
          systemStatus: data.systemStatus ? ConfigType.create(data.systemStatus).getValue() : undefined,
          report: report,
          createdAt: data.createdAt,
          createdBy: data.createdBy,
          assigner: data.assigner ? UserSummary.create(data.assigner).getValue() : undefined
        });
      } catch (error) {
        return Result.fail(error);
      }
    }
  }, {
    key: "fromJsonWithAssigner",
    value: function fromJsonWithAssigner(data) {
      return this.fromJson(data);
    }
  }]);

  return ParticipatedAssignmentResponder;
}(Entity);